import type { ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for radio style.
 *
 * @returns {ThemeStyle}
 */
export const getMuiRadioStyle = (): ThemeStyle => {
  return {
    root: {
      padding: '5px 10px 5px 0',
    },

    colorPrimary: {
      '&:hover': {
        background: 'transparent !important',
      },
    },
  };
};
